<template>
  <div class="authentication_page">
    <div class="title_box flex_center">
      <img src="./image/order_icon3.png" class="order_icon" />
      <div class="flex_column">
        <div class="order_title">授权书管理</div>
        <div class="order_subtitle"></div>
      </div>
    </div>
    <div class="filter_content font">
      <span class="order_subtitle">证书类型：</span>
      <el-select
        v-model="filterData.authenticationType"
        placeholder="请选择"
        class="mr12 width150"
        size="small"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span class="order_subtitle">证书状态：</span>
      <el-select
        v-model="filterData.verifyStatus"
        placeholder="请选择"
        class="mr12 width150"
        size="small"
      >
        <el-option
          v-for="item in options1"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span class="order_subtitle">是否过期：</span>
      <el-select
        v-model="filterData.expirType"
        placeholder="请选择"
        class="mr12 width150"
        size="small"
      >
        <el-option
          v-for="item in options2"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        style="background-color: #00a0e9; color: #ffffff; border-color: #00a0e9"
        size="small"
        @click="getInfo(1)"
      >
        查询</el-button
      >
      <el-button
        style="background-color: #00a0e9; color: #ffffff; border-color: #00a0e9"
        size="small"
        @click="toAdd"
      >
        新增</el-button
      >
    </div>
    <div class="content_box">
      <div class="table_content">
        <el-table
          :data="tableData"
          style="width: 100%; max-width: 1200px"
          v-loading="loading"
        >
          <el-table-column prop="authenticationTitle" label="名称">
          </el-table-column>
          <el-table-column prop="authenticationType" label="类型">
            <template slot-scope="scope">
              <div>
                {{
                  $enums.authenticationTypeEnum.getLabelByValue(
                    scope.row.authenticationType
                  )
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="verifyStatus" label="状态">
            <template slot-scope="scope">
              <div>
                {{
                  $enums.verifyStatusEnum.getLabelByValue(
                    scope.row.verifyStatus
                  )
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="authenticationExpirTime" label="有效期">
          </el-table-column>
          <el-table-column prop="createTime" label="上传时间">
          </el-table-column>
          <el-table-column prop="authenticationUrl" label="缩略图">
            <template slot-scope="scope">
              <div v-if="scope.row.authenticationFileSuffix !== 'pdf'">
                <el-image
                  style="width: 80px; height: 80px"
                  :src="scope.row.authenticationUrl"
                  :preview-src-list="[scope.row.authenticationUrl]"
                />
              </div>
              <div v-else>
                <span class="blue_text" @click="toDownLoad(scope.row)"
                  >下载pdf</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="flex_center">
                <el-button
                  type="text"
                  class="mr12 price"
                  @click="toChangeName(scope.row)"
                  >修改名称</el-button
                >
                <el-button
                  type="text"
                  class="mr12 price"
                  @click="toCancel(scope.row)"
                  v-if="scope.row.verifyStatus !== 'CANCEL'"
                  >作废</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex_end statics" v-if="pageInfo.total > 10">
          <el-pagination
            :current-page.sync="pageInfo.pageNo"
            :page-size="pageInfo.pageSize"
            layout="total, prev, pager, next"
            :total="pageInfo.total"
            @current-change="changePage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="授权书上传" :visible.sync="addModel.flag" width="520">
      <div>
        <el-form
          ref="ruleForm"
          :model="addModel"
          label-width="100px"
          :rules="rules"
        >
          <el-form-item label="证书名称" prop="authenticationTitle">
            <el-input
              v-model="addModel.authenticationTitle"
              placeholder="请输入证书名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="有效期" prop="authenticationExpirTime">
            <el-date-picker
              v-model="addModel.authenticationExpirTime"
              type="date"
              placeholder="选择日期有效期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="证书类型" prop="authenticationType">
            <el-radio-group v-model="addModel.authenticationType">
              <el-radio label="BRAND">品牌授权书</el-radio>
              <el-radio label="TRADE_MARK">商标注册书</el-radio>
              <el-radio label="PROXY">承印委托书</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="证书文件" prop="authenticationUrl">
            <img
              :src="addModel.authenticationUrl"
              alt=""
              v-if="addModel.authenticationUrl && addModel.authenticationFileSuffix !== 'pdf'"
              style="width: 200px;100px"
            />
            <div class="upload_box">
              <input type="file" accept="image/" @change="handleUpdataFile" />
              <i class="el-icon-box upload_icon"></i>
              <span class="bold">{{
                !addModel.authenticationUrl
                  ? "点击或拖拽文件至此处上传"
                  : "重新上传"
              }}</span>
              <span>.pdf,.jpg,.jpeg,.png,.PDF,.JPG,.JPEG,.PNG</span>
            </div>
            <span v-if="addModel.authenticationFileSuffix === 'pdf'" @click="toDownLoad(addModel)" class="blue_text">
              {{ addModel.fileName }}
            </span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addModel.flag = false">取 消</el-button>
        <el-button class="btn_style" type="primary" @click="sureAdd"
          >确 认</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="作废授权书" :visible.sync="cancelModel.flag" width="30%">
      <span>确定要作废授权书吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelModel.flag = false">取 消</el-button>
        <el-button class="btn_style" type="primary" @click="sureCancel"
          >确 认</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="修改证书名称"
      :visible.sync="changeNameModel.flag"
      width="30%"
    >
      <el-form label-width="100px">
        <el-form-item label="证书名称" prop="authenticationTitle">
          <el-input
            v-model="changeNameModel.authenticationTitle"
            placeholder="请输入证书名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeNameModel.flag = false">取 消</el-button>
        <el-button class="btn_style" type="primary" @click="sureChange"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  authenticationListApi,
  authenticationCancelApi,
  authenticationChangeNameApi,
  authenticationAddApi,
  getOssAuth,
} from "../../api/index";
export default {
  name: "authentication",
  data() {
    return {
      filterData: {
        timeDate: [],
        keywords: "",
        authenticationType: "",
        verifyStatus: "",
        expirType: "",
        tab: "ALL",
      },
      tableData: [],
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "BRAND",
          label: "品牌授权书",
        },
        {
          value: "TRADE_MARK",
          label: "商标注册书",
        },
        {
          value: "PROXY",
          label: "承印委托书",
        },
        {
          value: "BRAND_TRADE_MARK",
          label: "品牌授权书/商标注册书",
        },
      ],
      options1: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "VERIFYING",
          label: "未审核",
        },
        {
          value: "SUCCESS",
          label: "通过",
        },
        {
          value: "FAIL",
          label: "不通过",
        },
        {
          value: "CANCEL",
          label: "作废",
        },
      ],
      options2: [
        {
          value: "",
          label: "全部",
        },
        {
          value: false,
          label: "未过期",
        },
        {
          value: true,
          label: "已过期",
        },
      ],
      pageInfo: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
      addModel: {
        flag: false,
        authenticationId: 0,
        authenticationTitle: "11",
        authenticationExpirTime: "2025-11-11",
        authenticationType: "BRAND",
        authenticationFileSuffix: "",
        authenticationUrl: "",
        fileName: "",
        suffix: "",
      },
      rules: {
        authenticationTitle: [
          { required: true, message: "请输入证书名称", trigger: "blur" },
        ],
        authenticationExpirTime: [
          { required: true, message: "请选择日期有效期", trigger: "blur" },
        ],
        authenticationTitle: [
          { required: true, message: "请输入证书名称", trigger: "blur" },
        ],
      },
      cancelModel: {
        flag: false,
        authenticationId: "",
      },
      changeNameModel: {
        flag: false,
        authenticationId: "",
        authenticationTitle: "",
      },
    };
  },
  created() {},
  activated() {
    this.getInfo();
  },
  mounted() {},
  methods: {
    changePage(page) {
      this.pageInfo.pageNo = page;
      this.getInfo(this.pageInfo.pageNo);
    },
    getInfo(page = 1) {
      this.pageInfo.pageNo = page;
      if (this.loading) {
        return;
      }
      this.loading = true;
      authenticationListApi({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        authenticationType: this.filterData.authenticationType,
        verifyStatus: this.filterData.verifyStatus,
        expirType: this.filterData.expirType,
      })
        .then((res) => {
          if (res.resultStatus) {
            this.tableData = res.resultData.authenticationList || [];
            this.pageInfo.total = res.resultData.totalNum || 0;
          } else {
            this.tableData = [];
            this.pageInfo.total = 0;
            this.$message.warning(res.errorMessage);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toAdd() {
      this.addModel = {
        flag: true,
        authenticationId: 0,
        authenticationTitle: "",
        authenticationExpirTime: "",
        authenticationType: "BRAND",
        authenticationFileSuffix: "",
        authenticationUrl: "",
        fileName: "",
        suffix: "",
      };
    },
    sureAdd() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          authenticationAddApi({
            authenticationId: this.addModel.authenticationId,
            authenticationTitle: this.addModel.authenticationTitle,
            authenticationExpirTime: this.$moment(
              this.addModel.authenticationExpirTime
            ).format("YYYY-MM-DD"),
            authenticationType: this.addModel.authenticationType,
            authenticationFileSuffix: this.addModel.authenticationFileSuffix,
            authenticationUrl: this.addModel.authenticationUrl,
          })
            .then((res) => {
              if (res.resultStatus) {
                this.$message.success("新增授权书成功");
                this.addModel.flag = false;
                this.getInfo(1);
              } else {
                this.$message.warning(res.errorMessage);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 上传文件
    handleUpdataFile(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        if (file) {
          const form = new FormData();
          form.append("file", file);
          getOssAuth(form).then((res) => {
            if (res.resultStatus) {
              const suffix = res.resultData.suffix;
              if (
                [
                  "pdf",
                  "jpg",
                  "jpeg",
                  "png",
                  "PDF",
                  "JPG",
                  "JPEG",
                  "PNG",
                ].includes(suffix)
              ) {
                this.addModel.authenticationUrl = res.resultData.fileLink;
                this.addModel.authenticationFileSuffix = res.resultData.suffix;
                this.addModel.fileName = res.resultData.fileName;
              } else {
                this.$message.warning("请上传pdf,png,jpg,jepg格式的文件");
              }
            }
          });
        }
      }
    },
    toChangeName(data) {
      this.changeNameModel = {
        flag: true,
        authenticationId: data.authenticationId,
        authenticationTitle: data.authenticationTitle,
      };
    },
    sureChange() {
      authenticationChangeNameApi({
        authenticationId: this.changeNameModel.authenticationId,
        authenticationTitle: this.changeNameModel.authenticationTitle,
      })
        .then((res) => {
          if (res.resultStatus) {
            this.$message.success("授权书修改名称成功");
            this.changeNameModel.flag = false;
          }
        })
        .finally(() => {
          this.getInfo(1);
        });
    },
    toCancel(data) {
      this.cancelModel = {
        flag: true,
        authenticationId: data.authenticationId,
      };
    },
    sureCancel() {
      authenticationCancelApi({
        authenticationId: this.cancelModel.authenticationId,
      })
        .then((res) => {
          if (res.resultStatus) {
            this.$message.success("作废授权书成功");
            this.cancelModel.flag = false;
          }
        })
        .finally(() => {
          this.getInfo(1);
        });
    },
    toDownLoad(data) {
      this.$downLoadPDF(data.authenticationUrl, data.authenticationTitle);
    },
  },
};
</script>

<style lang="less">
.authentication_page {
  width: 100%;
  min-height: 100%;
  border: 1px solid #e1e1e1;
  padding: 20px;
  box-sizing: border-box;
  .title_box {
    margin-bottom: 12px;
  }
  .width200 {
    width: 200px;
  }
  .width150 {
    width: 150px;
  }
  .content_box {
    width: 100%;
    box-sizing: border-box;
    .table_content {
      width: 100%;
      box-sizing: border-box;
    }
    .statics {
      font-size: 14px;
      font-weight: bold;
      margin-top: 12px;
    }
  }
  .price {
    color: #00a0e9;
  }
  .upload_box {
    width: 400px;
    height: 150px;
    background: #f6f7f8;
    border-radius: 3px;
    border: 1px dashed #e1e1e1;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 13px 30px;
    box-sizing: border-box;
    input {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      font-size: 0;
      cursor: pointer;
      opacity: 0;
    }
    span {
      font-size: 13px;
      color: #999;
    }
    .bold {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .upload_icon {
    font-size: 24px;
    color: #00a0e9;
  }
  .blue_text {
    color: #00a0e9;
    cursor: pointer;
    text-decoration: underline;
  }
}
.el-tabs__item {
  color: #999;
}
.el-tabs__item:hover {
  color: #00a0e9;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border: 1px solid #2f4050;
  border-bottom: 0;
}
.el-tabs__item.is-active {
  color: #000000;
}
</style>